/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { useScript } from '@ttoss/hooks';

type SiflorApiContextType = { siflorApiLoaded: boolean; siflorApi: any };

export const SiflorApiContext = React.createContext<SiflorApiContextType>({
  siflorApiLoaded: false,
  siflorApi: {},
});

export const SiflorApiProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const url =
    'https://bkt-siflor-static-dev.s3.sa-east-1.amazonaws.com/js/siflorapi.js';

  const { status } = useScript(url);

  const siflorApiLoaded = React.useMemo(() => {
    return status === 'ready';
  }, [status]);

  const siflorApi = React.useMemo(() => {
    if (siflorApiLoaded) {
      return (window as any).siflorAPI;
    }
  }, [siflorApiLoaded]);

  if (!siflorApiLoaded) {
    return null;
  }

  return (
    <SiflorApiContext.Provider
      value={{
        siflorApiLoaded,
        siflorApi,
      }}
    >
      {children}
    </SiflorApiContext.Provider>
  );
};
